export default {
  themeColor: localStorage.getItem('themeColor') || '#c70019',
  locale: localStorage.getItem('lang') || 'zhCn',
  notificationCount: 0,
  notificationList: localStorage.getItem('用户', '角色', '机构', '菜单'),
  trainInfo: {}//故障开立传递数据使用
}
